export default __webpack_public_path__ + "static/media/sprintPlan.76690e2e.png";